<app-navbar-style-three></app-navbar-style-three>

<div class="page-title-area bg-image" style="height: 250px">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-content">
          <h2>Admission Informations</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="subscribe-wrap-area bg-light py-5">
  <div class="container">
    <div class="subscribe-wrap-inner-box p-4 p-md-5 rounded shadow-sm bg-white">
      <h1 class="my-4 text-center fw-bold" style="color: #020689;">Admission Notice</h1>
      <div class="text-center mb-4">
        <a target="_blank"
          href="https://cpscbusms-c148.s3.ap-southeast-1.amazonaws.com/dws/2026/notice/Notice_২০২৬-২৭ শিক্ষাবর্ষে একাদশ শ্রেণিতে অনলাইনে ভর্তির _17-09-2026-04-03-56_s.pdf"
          class="btn btn-lg button">Click for Notice Board</a>
      </div>
            <div class="text-center mb-4">
        <a target="_blank"
          href="https://vortibd.com/institute/137/505"
          class="btn btn-lg button">School Admission 2027 (Bangla and English Version) </a>
      </div>

      <div class="admission-guidelines p-3 p-md-4 rounded mb-5" style="background: #f8fafc; border: 1px solid #e2e8f0; line-height: 1.8; color: #1e293b;">
        <h3 class="fw-bold mb-2 text-center text-md-start" style="color: #020689; font-size: 22px;">
          কলেজ শাখায় ২০২৬-২০২৭ শিক্ষাবর্ষে ভর্তির জরুরী নির্দেশিকা
        </h3>
        <p class="fw-bold text-danger mb-4" style="font-size: 16px;">
          ভর্তির তারিখঃ ২০ সেপ্টেম্বর থেকে ২২ সেপ্টেম্বর ২০২৬ পর্যন্ত
        </p>

        <p class="mb-3">
          <strong>১।</strong> শিক্ষার্থী/অভিভাবককে সর্বপ্রথম <a href="http://www.cpscbusms.edu.bd" target="_blank" style="color: #020689; text-decoration: underline;">www.cpscbusms.edu.bd</a> ওয়েব সাইটে প্রবেশ করে একাদশ শ্রেণির ভর্তির লিংকে (XI Admission-2026-2027) Login করতে হবে। প্রয়োজনীয় সকল তথ্য পূরণ করে সাবমিট করলে স্বয়ংক্রিয়ভাবে শিক্ষার্থী একটি আইডি নম্বর পেয়ে যাবে। উক্ত আইডি নম্বর দিয়ে শিক্ষার্থী/অভিভাবককে (প্রতিষ্ঠানের ব্যাংক বুথ, টিক্যাশ, বিকাশ, রকেট ইত্যাদি মাধ্যমে) ভর্তির টাকা পরিশোধ করতে হবে।
        </p>

        <p class="mb-3">
          <strong>২।</strong> অনলাইনে পূরণকৃত ফরম এক কপি প্রিন্ট করে ভর্তির জন্য প্রয়োজনীয় কাগজপত্র (প্রবেশপত্র, রেজিস্ট্রেশন কার্ড, অনলাইন থেকে প্রিন্ট করা নম্বরপত্র/একাডেমিক ট্রান্সক্রিপ্ট, প্রশংসাপত্রের মূলকপি এবং এক সেট ফটোকপি, চার কপি পাসপোর্ট সাইজের ছবি, কোটা/সামরিক বাহিনীর সদস্যদের ক্ষেত্রে প্রত্যয়নপত্র/প্রয়োজনীয় দলিল, শিক্ষার্থীর জন্মনিবন্ধন সনদের ফটোকপি, বাবা-মায়ের জাতীয় পরিচয়পত্রের ফটোকপি) ভর্তি কমিটির নিকট জমা দিয়ে রোল নম্বর সংগ্রহ করতে হবে।
        </p>

        <p class="mb-3">
          <strong>৩।</strong> শিক্ষাবোর্ডের নির্দেশনা মোতাবেক নির্বাচিত ছাত্র-ছাত্রীদের আগামী ২০/০৯/২০২৬ তারিখ থেকে ২২/০৯/২০২৬ তারিখের মধ্যে (সকাল ০৯০০ ঘটিকা থেকে ১৩৩০ ঘটিকা পর্যন্ত) ফরম সংগ্রহ ও পূরণ করতঃ নির্ধারিত ফি জমা দিয়ে ভর্তি কার্যক্রম শেষ করার জন্য বলা হলো।
        </p>

        <p class="mb-4">
          <strong>৪।</strong> অনলাইনে শিক্ষার্থীর প্রয়োজনীয় তথ্য পূরণ করে প্রিন্টকৃত আবেদন ফরম, চাহিদা মোতাবেক সকল কাগজ ও ভর্তির টাকা জমার মূল রশিদ ভর্তি কমিটির নিকট জমা দিয়ে ভর্তি কার্যক্রম শেষ করতে হবে, নতুবা উক্ত শিক্ষার্থীর কলেজ কর্তৃক নিশ্চায়ন করা সম্ভব হবে না এবং তার ভর্তি স্বয়ংক্রিয়ভাবে বাতিল হয়ে যাবে।
        </p>

        <h4 class="fw-bold mt-4 mb-3 pt-3" style="color: #020689; font-size: 19px; border-top: 2px dashed #cbd5e1;">
          ভর্তির সময় যে সকল কাগজপত্র প্রতিষ্ঠানে জমা দিতে হবে
        </h4>

        <p class="mb-2"><strong>১।</strong> প্রতিষ্ঠানের অভ্যন্তরে অনলাইনে পূরণকৃত শিক্ষার্থীর আবেদন ফরম।</p>
        <p class="mb-2"><strong>২।</strong> এসএসসি পরীক্ষার প্রবেশপত্র, রেজিস্ট্রেশন কার্ড, প্রশংসাপত্রের মূল কপি এবং একাডেমিক ট্রান্সক্রিপ্টের অনলাইন প্রিন্ট করা কপি ও প্রত্যেক কাগজের এক সেট ফটোকপি।</p>
        <p class="mb-2"><strong>৩।</strong> চার কপি পাসপোর্ট সাইজের এবং দুই কপি স্ট্যাম্প সাইজের (সত্যায়িত ছাড়া) রঙিন ছবি।</p>
        <p class="mb-2"><strong>৪।</strong> ছাত্র-ছাত্রীর জন্ম নিবন্ধন কার্ডের ফটোকপি।</p>
        <p class="mb-2"><strong>৫।</strong> কোটার ক্ষেত্রে প্রয়োজনীয় কাগজপত্রের সত্যায়িত ফটোকপি।</p>
        <p class="mb-2"><strong>৬।</strong> আর্মি/এমইএস এর সন্তানদের ক্ষেত্রে ইউনিট প্রধানের প্রত্যয়ন পত্র। অবসরপ্রাপ্তদের ক্ষেত্রে চাকরীরত ছিলেন এই মর্মে সংশ্লিষ্ট প্রয়োজনীয় কাগজপত্র জমা দিতে হবে।</p>
        <p class="mb-2"><strong>৭।</strong> বাবা ও মায়ের জাতীয় পরিচয়পত্রের ফটোকপি, ২ কপি করে পাসপোর্ট সাইজের ছবি।</p>
        <p class="mb-2"><strong>৮।</strong> মূল কাগজ/ফটোকপি প্রতিষ্ঠানে জমার পূর্বে প্রতিটি কাগজের একসেট ফটোকপি ছাত্র-ছাত্রীদের নিজেদের সংরক্ষণে রাখার জন্য বলা হল। ভর্তির পর ফাইনাল পরীক্ষা পর্যন্ত মূল কাগজ বা ফটোকপি প্রতিষ্ঠান থেকে সরবরাহ করা হবে না।</p>
      </div>

      <h2 class="mt-4 mb-3 fw-bold" style="color: #020689;">Admission Options</h2>
      <div class="row">
        <div class="col-12 mb-4">
          <div class="d-flex flex-wrap align-items-center p-3 rounded" style="background: #f1f5f9; border: 1px solid #e2e8f0;">
            <h3 class="mb-0 me-3" style="font-size: 20px; font-weight: 600; color: #1e293b; margin-right: 15px;">
              XI Admission-2026-2027: -
            </h3>
            <a href="https://cpscbusmsxi.cloudcampus24.com/"
              target="_blank"
              class="btn btn-lg button my-2 my-sm-0"
              style="margin-left: 10px;">Click Link</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>